<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-row>
        <!-- Inicio Panel FILTRO -->
        <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
          <vs-card>
            <div slot="header">
              <h3 class="card-title mb-0">Información de filtro</h3>
            </div>
            <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
            <vs-row>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <!-- Selector de empresa -->
                <company-selector v-model="companyId"/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha de inicio</label>
                <vs-input type="date" v-model="initialDate" class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha de fin</label>
                <vs-input type="date" v-model="finalDate" class="w-100 "/>
              </vs-col>
            </vs-row>
            <br/>
            <vs-row>
              <!-- Selector de tipo de servicio -->
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12" v-if="thereStations">
                <label class="vs-input--label">Estación de pago</label>
                <multiselect v-model="selectedStations" placeholder="Seleccione una estación" label="name"
                             track-by="code" :options="showStations" :multiple="true"
                             :taggable="true" :max-height="150" :max="50">
                </multiselect>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12" v-if="thereMethods">
                <label class="vs-input--label">Método de pago factura</label>
                <multiselect v-model="selectedMethods" placeholder="Seleccione un método de pago" label="name"
                             track-by="code" :options="showMethods" :multiple="true"
                             :taggable="true" :max-height="150" :max="50">
                </multiselect>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12" v-if="thereBill">
                <label class="vs-input--label">Número de factura</label>
                <vs-input type="text" v-model="searchBillNumber" class="w-100 "/>
              </vs-col>
            </vs-row>
            <vs-row>
            </vs-row>
            <hr class="custom-hr"/>
            <div class="d-inline-block d-md-flex align-items-center">
              <div class="btn-alignment">
                <vs-button :disabled="!isSearch" @click="listPreview()">Buscar</vs-button>
                <vs-button color="gray" @click="clearForm()">Limpiar</vs-button>
              </div>
              <div class="ml-auto mt-3 mt-md-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                    <vs-button :disabled="!isDownloadable" class="btnx" type="filled" color="danger"
                               @click="downloadReport()">
                      <i class="ti-upload mr-2"></i>Exportar
                    </vs-button>

                    <vs-dropdown>
                      <vs-button class="btn-drop" type="filled" color="danger" icon="expand_more"></vs-button>
                      <vs-dropdown-menu>
                        <vs-button class="dropdown-item" color="'default'" v-for="document in documents"
                                   :value="document.id" :key="document.id"
                                   :id="document.id" @click="formatType=document.id">{{ document.name }}
                        </vs-button>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </vs-card>
        </vs-col>
        <vs-col vs-lg="12" vs-xs="12" v-if="showTable">
          <vs-card>
            <h3 class="card-title d-flex">
              Tabla de previsualización
            </h3>
            <div class="border" style="max-height: 43em;
              overflow-y: auto;">
              <vs-table :data="tableData">
                <template slot="thead">
                  <vs-th>Prefijo</vs-th>
                  <vs-th>Número de factura</vs-th>
                  <vs-th>Fecha de creación</vs-th>
                  <vs-th>Método de pago</vs-th>
                  <vs-th>Subtotal</vs-th>
                  <vs-th>Impuesto</vs-th>
                  <vs-th>Total facturado</vs-th>
                  <vs-th>Detalle de conceptos</vs-th>
                  <vs-th>Copia de factura</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr,indextr) in data">
                    <vs-td :data="data[indextr].prefix">
                      {{ data[indextr].prefix }}
                    </vs-td>
                    <vs-td :data="data[indextr].billNumber">
                      {{ data[indextr].billNumber }}
                    </vs-td>
                    <vs-td :data="data[indextr].billDate">
                      {{ data[indextr].billDate }}
                    </vs-td>
                    <vs-td :data="data[indextr].payMethod">
                      {{ data[indextr].payMethod }}
                    </vs-td>
                    <vs-td :data="data[indextr].subtotal">
                      {{ data[indextr].subtotal }}
                    </vs-td>
                    <vs-td :data="data[indextr].taxt">
                      {{ data[indextr].tax }}
                    </vs-td>
                    <vs-td :data="data[indextr].total">
                      {{ data[indextr].total }}
                    </vs-td>
                    <vs-td :data="data[indextr]">
                      <vs-button class="flex-shrink-0 small   ml-auto"
                                 color="primary"
                                 @click="view(data[indextr])"
                      >Conceptos
                      </vs-button>
                    </vs-td>
                    <vs-td :data="data[indextr]">
                      <vs-button class="flex-shrink-0 small   ml-auto"
                                 color="primary"
                                 @click="copyInvoice(data[indextr])"
                      >Copia
                      </vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-pagination :total="Math.ceil(total/perPage)" :per-page="perPage" v-model="page"/>
            </div>
            <vs-prompt
                color="primary"
                :active.sync="activePrompt"
                title="Conceptos de factura"
            >
              <div v-bar class="vs-scrollable" style="height: 350px;">
                <div>
                  <div class="p-2 pb-0">
                    <h3 style="font-weight: 100" class="mb-2">Ajuste de factura</h3>
                    <h2 class="mb-3">{{ movementSelected.adjust }}</h2>
                    <hr>
                    <h3 style="font-weight: 100" class="mb-2">Parqueadero bicicletas</h3>
                    <h2 class="mb-3">{{ movementSelected.parkBike }}</h2>
                    <hr>
                    <h3 style="font-weight: 100" class="mb-2">Tarjeta perdida bicicleta</h3>
                    <h2 class="mb-3">{{ movementSelected.lostCard }}</h2>
                    <hr>
                    <h3 style="font-weight: 100" class="mb-2">Mensual biciparqueadero</h3>
                    <h2 class="mb-3">{{ movementSelected.monthlyBike }}</h2>
                    <hr>
                    <h3 style="font-weight: 100" class="mb-2">Casillero moto</h3>
                    <h2 class="mb-3">{{ movementSelected.lockerMotorcycle }}</h2>
                    <hr>
                    <h3 style="font-weight: 100" class="mb-2">Casillero bicicleta</h3>
                    <h2 class="mb-3">{{ movementSelected.lockerBike }}</h2>
                    <hr>
                    <h3 style="font-weight: 100" class="mb-2">Mensual casillero moto</h3>
                    <h2 class="mb-3">{{ movementSelected.monthlyLockerMotorcycle }}</h2>
                    <hr>
                    <h3 style="font-weight: 100" class="mb-2">Mensual casillero bicicleta</h3>
                    <h2 class="mb-3">{{ movementSelected.monthlyLockerBike }}</h2>
                    <hr>
                    <h3 style="font-weight: 100" class="mb-2">Tiquete QR perdido</h3>
                    <h2 class="mb-3">{{ movementSelected.lostTicket }}</h2>

                  </div>
                </div>
              </div>
            </vs-prompt>
          </vs-card>
        </vs-col>
        <!-- Fin de tabla de datos -->

      </vs-row>
    </vs-col>
  </vs-row>
</template>
<script>
import companySelector from "@/components/Shared/CompanySelector";
import {ROUTES} from "@/global/api_routes";
import toast from "@/global/ToastConfig";
import DateUtils from "@/global/DateUtils";
import centroMayorEndpoint from "@/endpoints/reports/centro-mayor/centroMayorEndpoint";
import deviceEndpoint from "@/endpoints/machine/DeviceEndpoint";
import unityEndpoint from "@/endpoints/core/UnityEndpoint";
import multiselect from "vue-multiselect";

export default {
  components: {
    companySelector,
    multiselect,
  },
  data() {
    return {
      initialDate: null,
      finalDate: null,
      companyId: null,
      isLoading: false,
      showTable: false,
      tableData: [],
      activePrompt: false,
      page: 1,
      perPage: 50,
      total: 0,
      movementSelected: {},
      documents: [
        {name: ".xlsx", id: "xlsx"},
      ],
      totalPages: 0,
      thereStations: false,
      selectedStations: [],
      showStations: [],
      listStations: [],
      thereMethods: false,
      selectedMethods: [],
      showMethods: [],
      listMethods: [],
      searchBillNumber: null,
      thereBill: false,
      isSearch: false,
      isDownloadable: false,
      forceRender: 0,
    }
  },
  watch: {
    /**
     * Observa el companyId y realiza una accion si este cambia
     */
    companyId() {
      this.showTable = false;
      this.tableData = [];
      this.showStations = [];
      this.showMethods = [];
      this.selectedStations = [];
      this.selectedMethods = [];
      this.page = 1;
      this.validateParams();
    },
    /**
     * Observa el initialDate y realiza una accion si este cambia
     */
    initialDate() {
      this.showTable = false;
      this.tableData = [];
      this.showStations = [];
      this.showMethods = [];
      this.selectedStations = [];
      this.selectedMethods = [];
      this.page = 1;
      this.validateParams();
    },
    /**
     * Observa el finalDate y realiza una accion si este cambia
     */
    finalDate() {
      this.showTable = false;
      this.tableData = [];
      this.showStations = [];
      this.showMethods = [];
      this.selectedStations = [];
      this.selectedMethods = [];
      this.page = 1;
      this.validateParams();
    },
    /**
     * Observa el page y realiza una accion si este cambia
     */
    page() {
      this.listPreview();
    },
    selectedStations() {
      this.page = 1;
      this.tableData = [];
      this.showTable = false;
    },
    selectedMethods() {
      this.page = 1;
      this.tableData = [];
      this.showTable = false;
    },
    searchBillNumber() {
      this.tableData = [];
      this.showTable = false;
      this.page = 1;
    },
    showMethods() {
      this.isSearch = false;
      this.isDownloadable = false;
      if (this.showMethods.length > 0) {
        this.isSearch = true;
        this.isDownloadable = true;
      }
    }
  },
  methods: {
    /**
     * Metodo que limpia el formulario inicial
     */
    clearForm() {
      this.companyId = null;
      this.initialDate = null;
      this.finalDate = null;
      this.showTable = false;
      this.tableData = [];
      this.thereBill = false;
      this.thereMethods = false;
      this.selectedMethods = [];
      this.selectedStations = [];
      this.searchBillNumber = null;
      this.isSearch = false;
      this.isDownloadable = false;
      this.page = 1;
    },
    /**
     * metodo que valida si los parametros  de los servicios de traer los
     * metodos de pago y las estaciones son los correctos si no sale y no los muestra y no ejecuta el servicio
     * @returns {Promise<void>}
     */
    async validateParams() {
      if (!this.companyId) {
        this.thereStations = false;
        this.thereMethods = false;
        this.thereBill = false;
        return;
      }
      if (!this.finalDate || !this.initialDate) {
        this.thereStations = false;
        this.thereMethods = false;
        this.thereBill = false;
        return;
      }
      this.listDevices();
      this.thereStations = true;
      this.listMethod();
      this.thereMethods = true;
      this.thereBill = true;


    },
    /**
     * Metodo que asigna los parametros para descarga y previsualizacion del reporte
     * @returns {{finalDate: string, companyId: null, initialDate: string}}
     */
    prepareParameters() {
      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({
          date: this.initialDate,
        }),
        finalDate: DateUtils.toDateShortString({
          date: this.finalDate,
        }),
        page: this.page - 1,
        typeMethods: this.getValidateMethods(),
        typeDevices: this.getValidateStations(),
        billsNumber: this.searchBillNumber
      }
    },
    /**
     *  metodo que valida si seleccionaron una estacion o si no que tenga encuenta todas las estaciones
     * @returns {string}
     */
    getValidateStations() {
      return this.selectedStations.length === 0
          ? this.showStations.map(item => item.code).join(",")
          : this.selectedStations.map(item => item.code).join(",")
    },
    /**
     *  metodo que valida si seleccionaron un metodo de pago o si no que tenga encuenta todos los metodos
     * @returns {string}
     */
    getValidateMethods() {
      return this.selectedMethods.length === 0
          ? this.showMethods.map(item => item.code).join(",")
          : this.selectedMethods.map(item => item.code).join(",")
    },
    /**
     * Metodo que valida mis parametros en la interfaz grafica
     * para no hecer peticiones erroneas al servidor
     * @returns {Promise<void>}
     */
    async validateForm() {
      if (!this.finalDate || !this.initialDate) {
        throw new Error("Debe seleccionar fecha inicial y/o fecha final");
      }
      const validationResult = await this.$validator.validateAll();
      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (validDates) {
        throw new Error("Fecha final no puede ser inferior a fecha inicial");
      }
      if (!validationResult) {
        throw new Error("Complete el formulario");
      }
      if (!this.companyId) {
        throw new Error("Seleccione una compañia");
      }
    },
    /**
     * Metodo de descarga del reporte por medio de una promesa
     * @returns {Promise<void>}
     */
    async downloadReport() {
      try {
        await this.validateForm();
        this.isLoading = true;
        const objParams = this.prepareParameters();
        centroMayorEndpoint.downloadInvoiceMall(objParams)
            .then(data => {
              if (data.code < 0) {
                this.isLoading = false;
                return;
              }
              this.isLoading = false;
              let a = document.createElement("a");
              const urlFile =
                  process.env.VUE_APP_URL + ROUTES.GLOBAL.DOWNLOAD_FILE + data.info;
              a.href = urlFile;
              document.body.appendChild(a);
              console.log(urlFile);
              a.download = urlFile;
              a.click();
            })
      } catch (error) {
        toast.error(error);
      }
    },
    /**
     * Metodo que genera la previsualizacion de la tabla por medio de una promesa
     * @returns {Promise<void>}
     */
    async listPreview() {
      try {
        await this.validateForm();
        this.isLoading = true;
        const objParams = this.prepareParameters();
        centroMayorEndpoint.listInvoiceMall(objParams)
            .then(info => {
              this.isLoading = false;
              this.tableData = info.records;
              this.total = info.total;
              this.showTable = true;
            });

      } catch (error) {
        toast.error(error);
      }
    },
    /**
     *
     * @returns {Promise<void>}
     */
    async listMethod() {
      try {
        this.showMethods = [];
        await this.validateForm();
        this.isLoading = true;
        const objParams = this.prepareParameters();
        unityEndpoint.listByPayAndBilling(objParams)
            .then(data => {
              if (data.length === 0) {
                this.isLoading = false;
                return;
              }
              console.log(data);
              data.forEach((unityC) => {
                const concept = {
                  name: unityC.title,
                  code: unityC.code,
                };
                this.showMethods.push(concept);
              });
            });
        this.isLoading = false;
      } catch (error) {
        toast.error(error);
      }
    },
    /**
     * metodo que lista las estaciones que facturaron en el rango de fecha ingresado
     * @returns {Promise<void>}
     */
    async listDevices() {
      try {
        this.showStations = [];
        await this.validateForm();
        this.isLoading = true;
        const objParams = this.prepareParameters();
        deviceEndpoint.listByBillingRange(objParams)
            .then(data => {
              if (data.length === 0) {
                this.isLoading = false;
                return;
              }
              console.log(data);
              data.forEach((station) => {
                const unity = {
                  name: station.nickname,
                  code: station.code,
                };
                this.showStations.push(unity);
              });
            });
        this.isLoading = false;
        this.forceRender++;
      } catch (error) {
        toast.error(error.message);
      }
    },
    /**
     * Metodo que recolecta los datos a mostrar cuando  dan click en ver los detalles de los conceptos en la tabla
     * @param conceptObj
     */
    view(conceptObj) {
      console.log(conceptObj, typeof (conceptObj));
      this.movementSelected = conceptObj;
      this.activePrompt = true;
    },
    /**
     * Metodo que recolecta los datos para realizar la descarga de l copia de factura
     * @param invoiceInfo
     * @returns {Promise<void>}
     */
    async copyInvoice(invoiceInfo) {
      try {
        this.isLoading = true;
        const params = {
          companyId: this.companyId,
          invoicePrefix: invoiceInfo.prefix,
          invoiceNumber: invoiceInfo.billNumber,
          dateSearch: invoiceInfo.billDate,
        }
        centroMayorEndpoint.downloadMallInvoiceCopy(params)
            .then(data => {
              if (data.code < 0) {
                this.isLoading = false;
                return;
              }
              this.isLoading = false;
              let a = document.createElement("a");
              const urlFile =
                  process.env.VUE_APP_URL + ROUTES.GLOBAL.DOWNLOAD_FILE + data.info;
              a.href = urlFile;
              document.body.appendChild(a);
              console.log(urlFile);
              a.download = urlFile;
              a.click();
            });
        this.isLoading = false;
      } catch (error) {
        toast.error(error.message);
      }
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>